import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import {
    TextField, Button, Grid, Typography
} from '@material-ui/core';

import history from '#/history';
import { entriesToObject, resolveValidation } from '#/meta';
import rgx from '#/regex';

import { actions } from './sagaSlice';

const validators = {
    email: val => !!val && resolveValidation(val, rgx['email']),
    password: val => !!val && resolveValidation(val, rgx['password'])
};

const semanticErrors = {
    email: {
        content: 'Enter valid email',
        pointing: 'below'
    },
    password: {
        content: 'Enter valid password',
        pointing: 'below'
    }
};

const checkErrors = payload => {

    const validations = Object.entries(payload).map(([key, val]) => [key, !validators[key](val)]);

    return entriesToObject(validations);
};

export default connect(state => ({
    isSignedIn: state.auth.isSignedIn,
    isFetching: state.auth.isFetching
}), actions)(props => {

    if (props.isSignedIn) {

        history.push('/');
    }

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState('');

    const isValid = payload => {

        const err = checkErrors(payload);
        setErrors(err);

        return !Object.values(err).includes(true);
    };

    const onSubmit = e => {

        e.preventDefault();

        const payload = {
            email,
            password
        };


        if (isValid(payload)) {

            props.login(payload);
        }

    };

    return (
        <form onSubmit={ onSubmit } loading={ props.isFetching }>


            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant='h4' children='Login' />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        required
                        fullWidth
                        name='email'
                        type='text'
                        placeholder='Email'
                        label='Email'
                        onChange={e => setEmail(e.target.value)}
                        error={ errors.email ? semanticErrors.email : false}
                    />
                </Grid >
                <Grid item xs={12}>

                    <TextField
                        required
                        fullWidth
                        name='password'
                        type='password'
                        placeholder='Password'
                        label='Password'
                        onChange={e => setPassword(e.target.value)}
                        error={ errors.password ? semanticErrors.password : false}
                    />
                </Grid >
                <Grid item xs={12}>
                    <Button type='submit'>Login!</Button>
                </Grid >
                <Grid item xs={12}>
                    &#8226; <Link to='/password/request'><Typography display='inline'>Forgot password?</Typography></Link>
                </Grid>
            </Grid>
        </form>
    );
});
